import gql from 'graphql-tag'
import assign from 'lodash/assign'
import clone from 'lodash/clone'
import base from 'app/queries/base'

export default {

    all: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllLoggerTypes($offset: Int, $limit: Int, $filter: LoggerTypeFilter, $sortField: LoggerTypeSortField, $sortDirection: SortDirection, $search: String) {
                    viewer {
                        allLoggerTypes(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField, sortDirection: $sortDirection, search: $search) {
                            totalCount
                            items {
                                id
                                title
                                loggerPrice
                                usagePrice
                                backofficePrice
                                failurePrice
                                manualRoundPrice
                                createdAt
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    search: null
                }
            },

            update: ({viewer}) => viewer.allLoggerTypes

        }, options);
    },

    find: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindLoggerType($typeId: ID!) {
                    viewer {
                        findLoggerType(id: $typeId) {
                            id
                            title
                            loggerPrice
                            usagePrice
                            backofficePrice
                            failurePrice
                            manualRoundPrice
                            createdAt
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findLoggerType

        }, options);
    }
}
